import React, { useState } from 'react';

interface Props {
  className?: string;
  isRight?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export const PaginationArrow: React.FC<Props> = ({
  className,
  isRight,
  disabled,
  onClick,
}): JSX.Element => {
  const [hover, setIsHover] = useState(false);
  const onEnter = () => {
    setIsHover(true);
  };
  const onLeave = () => {
    setIsHover(false);
  };

  const fill = hover && !isRight && !disabled ? '#29335C' : '#cdd5e5';
  return (
    <div
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      className={className}
      onClick={!disabled ? onClick : () => {}}
      style={disabled ? { opacity: '0.5', cursor: 'default' } : {}}
    >
      <svg
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transition: 'all 0.2s', transform: 'scale(0.95)' }}
      >
        <path
          d="M0.328427 6.80933C-0.109476 6.36239 -0.109476 5.63777 0.328427 5.19083C0.76633 4.7439 1.47631 4.7439 1.91421 5.19083L6.67157 10.0463C7.10948 10.4932 7.10948 11.2179 6.67157 11.6648C6.23367 12.1117 5.52369 12.1117 5.08579 11.6648L0.328427 6.80933Z"
          fill={fill}
          style={{ transition: 'all 0.2s' }}
        />
        <path
          d="M1.91374 6.80917C1.47584 7.2561 0.76633 7.25626 0.328427 6.80933C-0.109476 6.36239 -0.109476 5.63777 0.328427 5.19083L5.08532 0.3352C5.52322 -0.111734 6.2332 -0.111734 6.6711 0.3352C7.10901 0.782134 7.10901 1.50676 6.6711 1.95369L1.91374 6.80917Z"
          fill={fill}
          style={{ transition: 'all 0.2s' }}
        />
      </svg>
    </div>
  );
};
